import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${props => props.theme.colors.text};
  margin-bottom: 5px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid ${props => props.theme.colors.border_grey};
  
  &:last-child {
    border-bottom: none;
    font-weight: 600;
  }
`;

export const Label = styled.span`
  color: ${props => props.theme.colors.text};
  font-size: 14px;
`;

export const Value = styled.span`
  color: ${props => props.theme.colors.text};
  font-weight: 500;
  font-size: 14px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;
